module.exports = __webpack_public_path__ + "img/Jabr.e0ae5a38.png";